module.exports = __webpack_public_path__ + "static/img/title_index.a3e7c55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/title_index.png
// module id = mdc/
// module chunks = 1